<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="跟进记录" :width="1200" :open="true" :confirmLoading="state.loading" :maskClosable="false"
        @ok="onFormSubmit" @cancel="cancel" :footer="null">
        <a-card :bordered="false">
            <div class="table-page-search-wrapper">
                <a-form>
                    <a-row :gutter="48">
                        <a-col :md="6" :sm="24">
                            <a-form-item label="昵称">
                                <a-input v-model:value="queryParam.nickname" placeholder="请输入"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="步骤" name="new_step">
                                <a-select mode="multiple" v-model:value="queryParam.new_step" placeholder="请选择">
                                    <a-select-option :value="1">线索</a-select-option>
                                    <a-select-option :value="2">待办</a-select-option>
                                    <a-select-option :value="3">办理中</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="创建时间">
                                <BetweenTimePick v-model:value="queryParam.between_time"></BetweenTimePick>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="内容">
                                <a-input v-model:value="queryParam.record" placeholder="内容"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="loadData">查询</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination"
                @change="onChange" rowKey="id">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'nickname'">
                        {{ text }}
                    </template>
                    <template v-if="column.dataIndex == 'step'">
                        <a-tag color="green" v-if="record.new_step == 3"><span
                                v-if="record.old_step != record.new_step">
                                <span v-if="record.old_step == 3">办理中</span>
                                <span v-if="record.old_step == 2">待办</span>
                                <span v-if="record.old_step == 1">线索</span>
                                ->
                            </span>办理中</a-tag>
                        <a-tag color="red" v-if="record.new_step == 2"><span v-if="record.old_step != record.new_step">
                                <span v-if="record.old_step == 3">办理中</span>
                                <span v-if="record.old_step == 2">待办</span>
                                <span v-if="record.old_step == 1">线索</span>
                                ->
                            </span>待办</a-tag>
                        <a-tag color="gray" v-if="record.new_step == 1"><span v-if="record.old_step != record.new_step">
                                <span v-if="record.old_step == 3">办理中</span>
                                <span v-if="record.old_step == 2">待办</span>
                                <span v-if="record.old_step == 1">线索</span>
                                ->
                            </span>线索</a-tag>
                    </template>
                    <template v-else-if="column.dataIndex === 'operate'">
                        <!-- <a @click="handleEdit(record)">编辑</a> -->
                    </template>
                </template>
            </a-table>
        </a-card>
    </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, handleError } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import BetweenTimePick from '@/components/base/BetweenTimePick.vue'
const emit = defineEmits(['ok', 'cancel'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const columns = [
    {
        title: '昵称',
        dataIndex: 'nickname',
        width: 200
    },
    {
        title: '微信号',
        dataIndex: 'wxid',
        width: 150
    },
    {
        title: '步骤',
        dataIndex: 'step',
        width: 200
    },
    {
        title: '记录内容',
        dataIndex: 'record',
    },
    {
        title: '时间',
        dataIndex: 'created_at',
        width: 200
    },
    {
        title: '操作',
        dataIndex: 'operate',
        width: 100
    }
]
interface state {
    loading: boolean
}
const state = reactive<state>({
    loading: false,
})
let queryParam = reactive<any>({
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
})
const loadData = () => {
    state.loading = true
    let xiansuo_id = props.detailData ? props.detailData.id : 0
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/xiansuo/recordList',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize, xiansuo_id: xiansuo_id }, queryParam)
    }
    baseService(requestParam).then((res) => {
        state.loading = false
        pagination.total = res.data.total_records
        dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
    })
}
const onChange = (val) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}
const onFormSubmit = () => {
    emit('cancel')
}
const cancel = () => {
    emit('cancel')
}
</script>
<style lang="less" scoped></style>
